import { Container, Graphics } from "pixi.js"
import { DUST_COUNT, DUST_SPEED } from "./constants"
import { mod } from "./lib/mod"

export async function Dust({ player }) {
  const dust = new Container()
  const app = window.Game.app

  const particles = [...Array(DUST_COUNT)].map(() => {
    const particle = new Graphics().rect(-1, -1, 2, 2).fill("#fff")
    particle.x = Math.random() * app.screen.width
    particle.y = Math.random() * app.screen.height

    const speed = 1 + Math.random() * 1
    particle.speed = speed * DUST_SPEED
    particle.alpha = (speed - 1) * 0.15

    return particle
  })

  particles.forEach((particle) => dust.addChild(particle))

  const tick = (time) => {
    particles.forEach((particle) => {
      particle.x -= player.velocity.x * time.deltaTime * particle.speed
      particle.y -= player.velocity.y * time.deltaTime * particle.speed

      particle.y -= 0.2 * DUST_SPEED * time.deltaTime

      particle.x = mod(particle.x, app.screen.width)
      particle.y = mod(particle.y, app.screen.height)
    })
  }

  return { dust, tick }
}
